<script>
import AbstractLayoutSet from './abstract-layout-set';

export default {
  name: 'abstract-layout-set-details',
  mixins: [AbstractLayoutSet],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  watch: {
    id(newValue, oldValue) {
      if (Number(newValue) !== Number(oldValue)) this.fetchDetails();
    },
  },
  methods: {
    fetchDetails() {},
    clearDetails() {},
  },
  created() {
    this.fetchDetails();
  },
  beforeDestroy() {
    this.clearDetails();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/abstract/abstract-layout-set-details.vue